import { combineReducers } from "redux";
import ModuleReducers from "module/reducer";

export default combineReducers({
  ModuleReducers,
});
